import type { WikiBrandArticle } from './wikiBrandArticles';

const IMG_01 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/7e3bd338-1e37-4b2f-b09d-e8387526fb9e_compressed_fw-founder-01-2014-east-africa-fieldwork.webp';
const IMG_02 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/b930bc41-9124-4b29-adb4-64641adbcf3a_compressed_fw-founder-02-2015-antarctica-fieldwork.webp';
const IMG_03 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/83777e4b-1bed-49ca-9af8-854f899fd896_compressed_fw-founder-03-2017-botswana-early-team.webp';
const IMG_04 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/8ff0c9b3-0fe0-40c3-b2e5-3d4e84463eba_compressed_07-2024--.webp';
const IMG_05 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/0a2ab4ae-b4ba-4ff0-8337-86130914687a_compressed_fw-founder-05-2025-botswana-vumbura-plains.webp';
const IMG_06 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/ca0e7e3a-ef38-498e-a75e-ef4d5558c3fa_compressed_fw-founder-06-2026-botswana-safari.webp';
const IMG_07 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/1270d8b6-0a5b-417e-971e-15d360797a6c_compressed_fw-founder-07-2026-rwanda-gorilla-fieldwork.webp';
const IMG_08 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/47c97f4a-4cd8-4d3c-969f-bb77dd9eccc2_compressed_fw-founder-08-2026-rovos-rail-southern-africa.webp';

const BRAND_MEETINGS_DESKTOP = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/6a72a26a-2c06-451f-89b5-71bc29cc7af4_compressed_free-wilderness-brand-meetings-collage-desktop.webp';
const BRAND_MEETINGS_MOBILE = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/cc7a30fa-1138-4bb9-9618-a4174a0e66fd_compressed_free-wilderness-brand-meetings-collage-mobile.webp';

const WAA01 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/453bf3b4-6cb0-4bc2-9ac8-8dad0fca43d8_compressed_01-free-wilderness-lemala.webp';
const WAA02 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/98cc0e44-46f5-4418-8aac-94ec93d1f7ce_compressed_02-free-wilderness-singita.webp';
const WAA03 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/bf9d3a8f-334a-4a3d-9589-8d6390bce65a_compressed_03-free-wilderness-belmond.webp';
const WAA04 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/30251f7b-b4af-4e4a-97ef-d406ae9c9299_compressed_04-free-wilderness-one-nature.webp';
const WAA05 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/24e70989-40ac-45e8-b7d3-0e3cfa5e5d25_compressed_05-free-wilderness-angama.webp';
const WAA06 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/ae74946b-7106-4779-8755-4cf92fb23dbb_compressed_06-free-wilderness-machaba-safaris.webp';
const WAA07 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/0871445a-c279-4d60-9ab1-f1bc72f1effd_compressed_07-free-wilderness-jao-reserve.webp';
const WAA08 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/32a178c5-4036-414c-9473-fb7cc2c25512_compressed_08-free-wilderness-bushcamp-company.webp';
const WAA09 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/38e8c22e-ef86-48e1-b4f5-e0e065243898_compressed_09-free-wilderness-songa-africa.webp';
const WAA10 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/5d8b6390-586d-469e-8a9f-a41f9815c29b_compressed_10-free-wilderness-karibu-camps-lodges.webp';
const WAA11 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/529a582f-9c56-4124-bad6-188d5f979ba4_compressed_11-free-wilderness-acacia-collections.webp';
const WAA12 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/e44b9435-ccff-4bbb-bdbe-14798179afa1_compressed_12-free-wilderness-sisini-collections.webp';
const WAA13 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/27cb37d2-7a87-4396-b267-7a596bfa9999_compressed_13-free-wilderness-kantabile-afrika.webp';
const WAA14 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/dd2addd7-468e-4a49-b335-a88d6a7b2ba2_compressed_14-free-wilderness-okavango-hidden-gems.webp';
const WAA15 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/7e1bc4ec-66c6-4c20-a4f5-17045e84391f_compressed_15-free-wilderness-desert-delta-safaris.webp';

const SCOUT01 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/27813a18-1957-4573-aa29-e7e764bc69ac_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-001-0e6ffe24ac.webp';
const SCOUT02 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/9df4b98b-7368-4911-961f-4a9068e059cc_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-002-6b2f4cb2bb.webp';
const SCOUT03 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/f4d7fbe0-0cee-43e1-944e-c0c9a9b19b20_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-003-a9ccda7c0e.webp';
const SCOUT04 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/f3783b2f-72eb-46f9-b851-613c84d57de7_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-004-a30b55cc4a.webp';
const SCOUT05 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/60466da8-2b51-4acc-bb95-cc9807b5d98b_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-005-fb74d62d27.webp';
const SCOUT06 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/9615434d-0903-4460-9202-011faaad1d07_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-006-6aa15c0b8f.webp';
const SCOUT07 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/eb53a2c2-c8a6-4d4d-9fd3-b9d23488bbb4_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-007-2974396e93.webp';
const SCOUT08 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/49601c75-f1d5-4c6c-8a38-88c972290097_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-008-8c08689ed3.webp';
const SCOUT09 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/bd2aa065-f94a-42b9-b13d-ed91ded67f5d_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-009-ddf842b368.webp';

const brandMeetingsFaq = [
  {
    question: 'WAA是什麼展會？',
    answer: 'WAA是We Are Africa的簡稱，是在南非開普敦舉行的非洲高端旅行行業交流活動，連接非洲旅行品牌、專業買家和旅遊媒體，重點關注高端、創意和有責任感的非洲旅行方式。',
  },
  {
    question: '自由曠野旅行是否參加了WAA 2026？',
    answer: '2026年5月，自由曠野旅行前往南非開普敦參加We Are Africa 2026，並與多家非洲野奢酒店和旅行品牌進行現場交流。',
  },
  {
    question: '自由曠野旅行在WAA 2026交流了哪些品牌？',
    answer: '現場交流品牌包括Singita、Lemala Camps & Lodges、Belmond、One Nature、Angama、Machaba Safaris、Jao Reserve、The Bushcamp Company、Songa Africa、Karibu Camps & Lodges、Acacia Collections、Sisini Collection、Kantabile Afrika、Okavango Hidden Gems、Desert & Delta Safaris等數十家常合作的野奢品牌。',
  },
  {
    question: '雙方主要交流了什麼？',
    answer: '交流內容包括非洲Safari線路設計、遷徙季營地選擇、親子與蜜月需求、私人車輛、嚮導與活動匹配、跨境及小飛機銜接、在地服務、可持續旅行和突發情況響應。',
  },
  {
    question: '現場合影是否代表已經簽署正式合作協議？',
    answer: '不代表。現場合影能夠證明雙方進行過面對面交流並建立友好業務聯繫，但不單獨等同於簽約、獨家代理或官方授權。具體合作產品、價格、房態和權益以後續書面確認及實際預訂為準。',
  },
  {
    question: '這些交流對旅行者有什麼實際幫助？',
    answer: '直接溝通有助於自由曠野旅行更快了解營地位置、季節變化、兒童政策、活動限制和接駁條件，從而為不同客人設計更合適的路線，並在行程發生變化時提高溝通效率。',
  },
];

/* ─────────────────────────────────────────────
   人物故事：創始人·實地筆記（繁體）
   路由：/wiki/brand/founder-field-notes
   ───────────────────────────────────────────── */
const founderFieldNotesContent = `
<p class="text-base md:text-lg leading-[1.8] mb-6">一條旅行線路，究竟從哪裡開始？</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">對自由曠野旅行來說，它往往不是從酒店清單、網路圖片或一張地圖開始，而是從一次真實抵達開始：走進草原，坐進Safari車輛，住進營地，經歷不同季節的天氣和路況，再把沿途看到的問題一項項帶回行程設計中。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">自由曠野旅行（Free Wilderness Travel）由成都自由曠野國際旅行社有限公司運營，品牌與公司成立於2022年。品牌成立之前，創始人李志強已經在高端定製旅行行業積累了多年的目的地經驗。2013年，是他的個人從業起點，而不是當前公司的成立時間。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_01}" alt="2014年李志強在東非進行目的地實地考察" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2014年，李志強前往衣索比亞與坦桑尼亞進行目的地實地考察。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">從2013年出發，把目的地變成現場</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2013年進入高端定製旅行行業後，李志強開始長期接觸目的地研究、線路策劃與旅行服務。對當時的他來說，判斷一條線路是否合理，不能只看目的地有多著名，更要看旅行者真正抵達後會經歷什麼。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">2014年，他前往衣索比亞與坦桑尼亞。從城市銜接到東非草原，從長途交通到Safari節奏，這次抵達讓非洲不再只是資料中的目的地，而成為可以被觀察、比較和不斷修正的真實現場。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">三年後的2017年，早期從業團隊進入博茨瓦納，開展目的地考察，不僅了解營地銜接、輕型飛機交通與Safari旅行場景，也開始從地理位置、住宿風格和實際體驗等角度比較不同營地，為後續的行程設計與選店判斷積累現場經驗。這裡沒有統一複製的觀光路線：水位、季節、動物活動和營地位置，都可能改變一段旅程的體驗。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_03}" alt="2017年早期從業團隊在博茨瓦納進行目的地考察" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2017年，早期從業團隊在博茨瓦納了解營地、交通與Safari旅行場景。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">這些經歷逐漸形成一種工作習慣：在向客戶推薦之前，先盡可能理解目的地真實的運行方式。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">從非洲到極地，建立對自然旅行的判斷</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2015年，李志強第一次抵達南極，親身體驗極地航行、登陸活動和不斷變化的天氣環境。2019年，他又前往格陵蘭與冰島，將目的地經驗從南極延伸至北極圈。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_02}" alt="2015年李志強在南極進行實地體驗" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2015年，李志強第一次抵達南極，體驗極地環境與登陸活動。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">非洲草原和極地冰原看似完全不同，卻都要求旅行者尊重自然的不確定性。野生動物不會按照行程表出現，登陸點可能受天氣影響，營地體驗也會隨著季節變化。真正專業的規劃，不是承諾所有事情必然發生，而是提前理解變數，設計更合理的節奏，並為可能發生的變化留下空間。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">這也成為自由曠野後來進行非洲Safari和南北極自然旅行規劃時的重要原則。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">2022年，把個人積累轉化為品牌方法</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2022年，自由曠野旅行品牌與成都自由曠野國際旅行社有限公司成立。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">品牌沒有把2013年包裝成公司成立年份，而是明確區分兩段歷史：2013年是創始人的個人從業起點；2022年是當前品牌與公司主體的成立時間。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">成立自由曠野旅行，是希望把此前積累的目的地理解，轉化為一套更穩定的旅行服務方法。它不只關心「去哪些地方」，也關心每天的路程是否合理、營地之間怎樣銜接、嚮導是否了解動物、住宿體驗是否符合旅行者真正的偏好，以及國內協調如何讓遠距離旅行更安心。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">成立以後，繼續回到非洲</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">品牌成立並不意味著實地探索告一段落。2023年，李志強再次前往坦桑尼亞，從Safari車輛、線路節奏到營地體驗進行一線觀察。2024年，團隊與坦桑尼亞當地接待團隊面對面交流，繼續了解目的地運營、嚮導服務與現場協作。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_04}" alt="2024年李志強在坦桑尼亞與當地團隊進行現場交流" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2024年，李志強在坦桑尼亞與當地團隊交流目的地接待與現場協作。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">這些工作不一定會直接出現在一份行程單裡，卻會影響旅行的很多細節：某段車程是否過長、哪個區域更適合多住一晚、不同季節如何選擇營地、當地團隊遇到變化時怎樣響應。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">在博茨瓦納，看見Safari的另一種節奏</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2025年，團隊再次深入博茨瓦納，不只體驗Safari活動，也以真實住客視角入住和走訪多家野奢營地，從客房、餐飲、嚮導、活動節奏、轉場效率與服務細節等維度進行比較，為旅行者篩選更匹配的住宿選擇。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_05}" alt="2025年李志強在博茨瓦納Vumbura Plains進行實地體驗" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2025年，親自入住奧卡萬戈三角洲Wilderness多家營地，在水陸交錯的環境中體驗營地服務與Safari活動，觀察季節變化帶來的差異，並進一步判斷不同營地更適合攝影、親子、蜜月，還是偏愛私密感與深度Safari的旅行者。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">對高品質自然旅行而言，昂貴並不自動等於合適。營地所在區域、季節水位、活動方式、房間數量和整體氛圍，都會影響最終體驗。反覆回到同一目的地，是為了在不同時間和現場條件下重新觀察，而不是僅憑一次到訪就給出永久不變的答案。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">2026年，李志強繼續深入博茨瓦納，持續核驗不同區域、季節和價位的野奢營地真實入住體驗。根據旅行者的興趣、節奏與預算，匹配更合適的酒店和行程組合，讓預算優先投入真正重視的體驗；同時依託與當地多家酒店集團直簽合作，提高房態、價格與服務銜接的匹配效率。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_06}" alt="2026年李志強再次在博茨瓦納進行Safari實地考察" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2026年，李志強再次深入博茨瓦納進行Safari實地考察。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">從草原走進盧旺達山地森林</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2026年5月，李志強前往盧旺達開展山地大猩猩旅行實地體驗。與車輛Safari不同，山地大猩猩追蹤需要在專業人員帶領下進入森林，實際過程會受到地形、天氣和大猩猩當天活動位置等因素影響。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_07}" alt="2026年李志強在盧旺達山地大猩猩實地考察中留影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2026年5月，李志強在盧旺達山地大猩猩實地考察現場留影。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">這次抵達補充了團隊對東非山地森林旅行的現場理解：不僅要考慮追蹤許可證和交通時間，也要理解徒步強度、森林條件、住宿位置與現場組織之間的關係。照片記錄的是一次真實抵達，並不代表野生動物活動可以被預先保證。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">同年，李志強體驗南部非洲鐵路旅行產品。從草原營地到非洲之傲列車，團隊繼續補充對南部非洲交通、住宿和服務銜接的理解。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_08}" alt="2026年李志強體驗南部非洲非洲之傲列車" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2026年，李志強體驗南部非洲鐵路旅行產品與服務銜接。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">實地經歷最終要回到旅行者</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">對於客戶來說，目的地考察的價值並不在於展示去過多少國家，而在於這些經歷是否真正進入服務：</p>

<ul class="list-disc pl-6 mb-6 space-y-2 text-base md:text-lg leading-[1.8] text-[#1a2e10]">
  <li>設計行程時，減少不必要的往返和過度趕路；</li>
  <li>選擇營地時，不只看品牌名稱，也結合區域、季節和活動方式；</li>
  <li>安排Safari或森林追蹤時，理解當地嚮導和現場組織的重要性；</li>
  <li>面對動物活動、天氣和交通變化時，保留合理預期與應對空間；</li>
  <li>在長距離旅行中，做好國內溝通與海外落地服務之間的銜接。</li>
</ul>

<p class="text-base md:text-lg leading-[1.8] mb-6">從2013年的個人從業起點，到2022年自由曠野旅行成立，再到此後持續深入坦桑尼亞、博茨瓦納、盧旺達和南部非洲，變化的是時間與目的地，不變的是同一個判斷標準：沒有一種真正值得信任的自然旅行經驗，可以完全繞過現場。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">自由曠野旅行不會把每一次抵達包裝成獎項，也不會把不可預測的自然寫成保證。團隊更願意把路線重新走一遍，把營地真正住一次，把複雜的銜接親身經歷過，再把這些判斷放進下一位旅行者的行程裡。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">這條實地路徑仍在繼續。</p>

<div class="bg-[#e8f0e0] rounded-xl p-6 md:p-8 my-10">
  <p class="text-[#1a4a1a] font-bold text-lg mb-2">關於自由曠野旅行</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed">自由曠野旅行（Free Wilderness Travel）由成都自由曠野國際旅行社有限公司運營，品牌與公司成立於2022年，專注非洲Safari、南北極及自然類定製旅行。創始人李志強自2013年進入高端定製旅行行業，並與團隊持續進行目的地實地體驗、線路研究與在地資源交流。</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed mt-2">官方網站：<a href="https://freewds.com/" class="text-[#1a4a1a] hover:underline" target="_blank" rel="noopener noreferrer">https://freewds.com/</a></p>
</div>
`;

/* ─────────────────────────────────────────────
   品牌合作：合作交流合影（繁體）
   路由：/wiki/brand/brand-cooperation-exchange
   ───────────────────────────────────────────── */
const brandMeetingsContent = `
<p class="text-base md:text-lg leading-[1.8] mb-6">2026年5月，自由曠野旅行前往南非開普敦，參加非洲高端旅行行業展會 We Are Africa 2026（簡稱 WAA）。WAA 彙集非洲高端旅行品牌、國際買家與旅遊媒體，是了解新營地、新體驗和在地服務變化的重要行業交流平台。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">展會期間，自由曠野旅行與 Singita、Lemala、Belmond、One Nature、Angama 等數十家常合作的非洲野奢酒店及旅行品牌代表進行了面對面交流。雙方圍繞中國高端旅行者的真實需求、Safari線路組合、親子與蜜月產品、旺季資源協調、在地接待、可持續旅行和突發情況響應等議題交換了資訊，建立了直接、友好的合作聯繫，並形成後續逐項對接產品與服務的意向。</p>

<div class="bg-[#f0f5ea] rounded-xl p-6 md:p-8 mb-8">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div class="flex items-start gap-3">
      <i class="ri-calendar-line text-[#1a4a1a] text-lg mt-1"></i>
      <div>
        <p class="text-xs text-[#5a7a4a] mb-0.5">活動時間</p>
        <p class="text-sm font-semibold text-[#1a2e10]">2026年5月</p>
      </div>
    </div>
    <div class="flex items-start gap-3">
      <i class="ri-map-pin-line text-[#1a4a1a] text-lg mt-1"></i>
      <div>
        <p class="text-xs text-[#5a7a4a] mb-0.5">活動地點</p>
        <p class="text-sm font-semibold text-[#1a2e10]">南非開普敦</p>
      </div>
    </div>
    <div class="flex items-start gap-3">
      <i class="ri-flag-line text-[#1a4a1a] text-lg mt-1"></i>
      <div>
        <p class="text-xs text-[#5a7a4a] mb-0.5">活動名稱</p>
        <p class="text-sm font-semibold text-[#1a2e10]">We Are Africa 2026（WAA 2026）</p>
      </div>
    </div>
    <div class="flex items-start gap-3">
      <i class="ri-building-line text-[#1a4a1a] text-lg mt-1"></i>
      <div>
        <p class="text-xs text-[#5a7a4a] mb-0.5">交流品牌</p>
        <p class="text-sm font-semibold text-[#1a2e10]">數十家常合作的非洲野奢酒店及旅行品牌</p>
      </div>
    </div>
  </div>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <picture>
    <source media="(max-width: 768px)" srcset="${BRAND_MEETINGS_MOBILE}" />
    <img src="${BRAND_MEETINGS_DESKTOP}" alt="自由曠野旅行在We Are Africa 2026與數十家非洲野奢品牌代表交流合影" class="w-full h-auto object-cover" />
  </picture>
  <p class="text-sm text-stone-500 mt-2 text-center">自由曠野旅行在We Are Africa 2026與數十家非洲野奢品牌代表交流合影。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">為什麼自由曠野旅行要參加 WAA？</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">高端非洲Safari不是簡單地把酒店和車輛拼在一起。動物遷徙的位置會變化，奧卡萬戈三角洲的水位有季節差異，不同營地對兒童入住、私人用車、步行遊獵和包場體驗也有不同規則。對中國旅行者來說，真正影響旅程品質的，往往是路線節奏、營地組合、嚮導匹配、航班銜接和突發情況處理。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">參加 WAA 的價值，是讓自由曠野旅行能夠直接與品牌和在地團隊溝通，了解營地的新變化，並把中國客人的飲食、語言、親子、安全、攝影和私密性需求帶到供應端。與只依賴公開網頁資訊相比，面對面交流更有利於判斷一間營地適合什麼季節、什麼客群，以及應該如何放進一條完整路線。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">現場重點交流了哪些品牌？</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">以下內容根據現場交流主題及各品牌公開產品特點整理，不是逐字會議記錄，也不代表已經簽署排他或獨家協議。</p>

<div class="overflow-x-auto mb-8">
  <table class="w-full text-sm md:text-base border border-[#e8e0d4] rounded-xl overflow-hidden">
    <thead class="bg-[#e8f0e0]">
      <tr>
        <th class="px-4 py-3 text-left text-[#1a2e10] font-bold border-b border-[#e8e0d4]">品牌</th>
        <th class="px-4 py-3 text-left text-[#1a2e10] font-bold border-b border-[#e8e0d4]">主要目的地或資源方向</th>
        <th class="px-4 py-3 text-left text-[#1a2e10] font-bold border-b border-[#e8e0d4]">重點交流方向</th>
      </tr>
    </thead>
    <tbody class="divide-y divide-[#e8e0d4]">
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Singita</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亞及非洲多地</td><td class="px-4 py-3 text-[#5a7a4a]">格魯米提與塞倫蓋蒂高端住宿、私密體驗、保護與社區項目</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Lemala Camps & Lodges</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亞、烏干達</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亞北部環線、遷徙季營地組合、親子與私人用車</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Belmond</td><td class="px-4 py-3 text-[#5a7a4a]">博茨瓦納、南非</td><td class="px-4 py-3 text-[#5a7a4a]">開普敦與博茨瓦納聯遊、水陸空Safari組合</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">One Nature</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亞塞倫蓋蒂</td><td class="px-4 py-3 text-[#5a7a4a]">塞倫蓋蒂中部與北部組合、蜜月及紀念旅行</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Angama</td><td class="px-4 py-3 text-[#5a7a4a]">肯尼亞馬賽馬拉、安博塞利</td><td class="px-4 py-3 text-[#5a7a4a]">肯坦跨境、攝影、家庭與私人旅行</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Machaba Safaris</td><td class="px-4 py-3 text-[#5a7a4a]">博茨瓦納、津巴布韋</td><td class="px-4 py-3 text-[#5a7a4a]">三角洲與國家公園組合、獨木舟、步行和驅車遊獵</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Jao Reserve</td><td class="px-4 py-3 text-[#5a7a4a]">博茨瓦納奧卡萬戈三角洲</td><td class="px-4 py-3 text-[#5a7a4a]">六家營地組合、水陸體驗與不同水位季節</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">The Bushcamp Company</td><td class="px-4 py-3 text-[#5a7a4a]">贊比亞南盧安瓜</td><td class="px-4 py-3 text-[#5a7a4a]">步行Safari、營地串聯、嚮導與安全標準</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Songa Africa</td><td class="px-4 py-3 text-[#5a7a4a]">非洲多目的地</td><td class="px-4 py-3 text-[#5a7a4a]">定製線路、跨區域地接協同和服務響應</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Karibu Camps & Lodges</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亞北部環線</td><td class="px-4 py-3 text-[#5a7a4a]">塞倫蓋蒂、恩戈羅恩戈羅與塔蘭吉雷營地銜接</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Acacia Collections</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亞北部環線</td><td class="px-4 py-3 text-[#5a7a4a]">遷徙營地、生態住宿與家庭房型組合</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Sisini Collection</td><td class="px-4 py-3 text-[#5a7a4a]">塞倫蓋蒂、馬賽馬拉</td><td class="px-4 py-3 text-[#5a7a4a]">慢旅行、康養、在地餐飲與可持續體驗</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Kantabile Afrika</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亞塞倫蓋蒂</td><td class="px-4 py-3 text-[#5a7a4a]">Aurari與Cherero營地、遷徙季和小體量野奢體驗</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Okavango Hidden Gems</td><td class="px-4 py-3 text-[#5a7a4a]">博茨瓦納奧卡萬戈三角洲</td><td class="px-4 py-3 text-[#5a7a4a]">低密度營地、水上活動和私密Safari</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Desert & Delta Safaris</td><td class="px-4 py-3 text-[#5a7a4a]">博茨瓦納</td><td class="px-4 py-3 text-[#5a7a4a]">多營地環線、小飛機銜接、季節性水域體驗</td></tr>
    </tbody>
  </table>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">1. Singita：頂奢體驗不只在房間，也在保護理念與服務細節</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Singita在坦桑尼亞格魯米提、塞倫蓋蒂北部以及非洲其他保護區擁有營地、山莊和私人別墅。現場交流聚焦高私密度旅行、家庭及多人包棟、專業嚮導體驗，以及如何讓客人理解保護、社區與高端住宿之間的關係。雙方希望在後續產品設計中，把「住得奢華」與「真正理解目的地」放在同一條體驗線上。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA02}" alt="李志強與Singita代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Singita代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">2. Lemala Camps & Lodges：把坦桑尼亞北部環線做得更順</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Lemala在塞倫蓋蒂、恩戈羅恩戈羅、塔蘭吉雷及烏干達擁有營地和度假產品。雙方重點交流了坦桑尼亞北部環線的住宿組合、動物遷徙不同階段的營地選擇，以及親子家庭對私人車輛、連續住宿和餐飲溝通的需求。後續對接方向，是根據出行月份和家庭結構匹配合適的Lemala營地，而不是只按品牌知名度選酒店。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA01}" alt="李志強與Lemala Camps & Lodges代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Lemala Camps & Lodges代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">3. Belmond：從開普敦城市體驗延伸到博茨瓦納荒野</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Belmond在開普敦及博茨瓦納擁有酒店和Safari產品。交流重點是如何把城市停留與奧卡萬戈三角洲、薩武蒂等荒野體驗自然銜接，並結合驅車、船隻及觀景飛行等方式，減少單一活動帶來的重複感。蜜月、紀念旅行和希望兼顧舒適度的家庭，是雙方重點討論的客群。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA03}" alt="李志強與Belmond代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Belmond代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">4. One Nature：用塞倫蓋蒂中部與北部形成季節互補</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">One Nature的公開產品包括塞倫蓋蒂中部Nyaruswiga和北部Mara River。雙方討論了如何依據遷徙位置安排中部與北部住宿、如何控制連續換營地的疲勞，以及蜜月、生日和家庭紀念旅行對私密餐飲與個性化佈置的需求。重點不是追求「每天換一家」，而是讓客人在合適區域住夠時間。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA04}" alt="李志強與One Nature代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與One Nature代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">5. Angama：連接馬賽馬拉、安博塞利與東非跨境路線</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Angama的核心產品位於肯尼亞馬賽馬拉和安博塞利。雙方交流了肯尼亞與坦桑尼亞跨境線路的節奏、空中與陸路銜接、攝影客人的出發時間，以及多代家庭對空間和私人活動的需求。對於同時想看馬賽馬拉草原與乞力馬扎羅山景觀的客人，後續可以根據季節做更清晰的路線取捨。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA05}" alt="李志強與Angama代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Angama代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">6. Machaba Safaris：根據水位和季節組合博茨瓦納與津巴布韋</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Machaba Safaris在博茨瓦納和津巴布韋運營多家生態野奢營地。現場討論圍繞奧卡萬戈三角洲、喬貝、萬基與馬納潭等區域的組合邏輯，以及獨木舟、步行Safari和驅車遊獵如何互補。雙方特別關注水位變化對活動安排的影響，希望在行前就把「能看到什麼、能參加什麼」解釋清楚。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA06}" alt="李志強與Machaba Safaris代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Machaba Safaris代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">7. Jao Reserve：用不同營地看見奧卡萬戈的水與陸地</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Jao Reserve位於博茨瓦納奧卡萬戈三角洲，旗下營地呈現不同的水域和陸地生態。雙方交流了六家營地之間的差異、住幾晚更合理，以及獨木舟、船遊、步行和驅車體驗的季節適配。後續路線設計將更重視營地之間的生態差異，避免只換酒店、不換體驗。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA07}" alt="李志強與Jao Reserve代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Jao Reserve代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">8. The Bushcamp Company：把南盧安瓜步行Safari講清楚</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">The Bushcamp Company深耕贊比亞南盧安瓜，以步行Safari和小型營地串聯見長。雙方重點交流了步行強度、嚮導匹配、安全說明、行李轉運和營地之間的銜接。對於希望深入荒野而非只在車上觀獸的客人，贊比亞可以成為與東非完全不同的第二次Safari選擇。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA08}" alt="李志強與The Bushcamp Company代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與The Bushcamp Company代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">9. Songa Africa：強化跨目的地行程的在地協同</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Songa Africa專注非洲定製旅行與營地資源。交流內容集中在跨區域線路的落地執行，包括機場接送、內陸航班、供應商溝通、飲食偏好、臨時調整和緊急響應。雙方希望通過更直接的資訊鏈路，減少多國行程中因層層轉達產生的誤差。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA09}" alt="李志強與Songa Africa代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Songa Africa代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">10. Karibu Camps & Lodges：圍繞坦桑尼亞北部經典公園做組合</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Karibu Camps & Lodges的產品覆蓋塞倫蓋蒂、恩戈羅恩戈羅和塔蘭吉雷。雙方討論了不同營地的地理位置、連續住宿天數、家庭房型以及攝影客人的早出晚歸安排。後續將根據季節和客人關注的動物場景組合營地，不用同一套模板覆蓋全年。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA10}" alt="李志強與Karibu Camps & Lodges代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Karibu Camps & Lodges代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">11. Acacia Collections：兼顧遷徙位置、生態設計與家庭需求</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Acacia Collections在塞倫蓋蒂、塔蘭吉雷和恩戈羅恩戈羅佈局營地及生態住宿。現場交流包括遷徙營地的開放位置、家庭與蜜月房型、跨營地交通以及可持續運營實踐。雙方希望把這些資訊轉化成更透明的行前說明，讓客人知道營地位置為什麼會影響每天的遊獵時間。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA11}" alt="李志強與Acacia Collections代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Acacia Collections代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">12. Sisini Collection：把康養、餐飲與慢節奏放進Safari</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Sisini Collection強調與自然連接、康養和在地飲食體驗。雙方討論了塞倫蓋蒂與馬賽馬拉產品如何服務希望放慢節奏的客人，以及農場到餐桌、靜心休息和輕量自然活動如何與傳統驅車遊獵結合。這樣的產品更適合不希望每天從清晨趕到夜晚的旅行者。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA12}" alt="李志強與Sisini Collection代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Sisini Collection代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">13. Kantabile Afrika：小體量營地與塞倫蓋蒂遷徙季體驗</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Kantabile Afrika由業主設計並運營Aurari Camp和Cherero Camp，強調小體量、生態意識與在地審美。雙方重點交流了北部塞倫蓋蒂遷徙季、營地開放時間、私人車輛和紀念旅行安排，以及如何向中國客人解釋「小型營地」在私密性和服務溫度上的優勢。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA13}" alt="李志強與Kantabile Afrika代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Kantabile Afrika代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">14. Okavango Hidden Gems：低密度方式體驗三角洲</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Okavango Hidden Gems位於博茨瓦納奧卡萬戈三角洲區域。交流重點是永久水道附近的水上體驗、不同月份的景觀變化、小體量營地的私密性，以及適合情侶、家庭和小團體的活動節奏。雙方希望在產品中明確季節差異，避免把三角洲描述成全年完全相同的景觀。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA14}" alt="李志強與Okavango Hidden Gems代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Okavango Hidden Gems代表在WAA 2026現場合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">15. Desert & Delta Safaris：把博茨瓦納多營地環線銜接得更穩定</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Desert & Delta Safaris長期運營博茨瓦納多家Safari營地，並強調本地團隊管理。雙方討論了不同生態區域之間的小飛機銜接、旱季與水季差異、連續入住和多營地組合，以及在突發航班變化時的資訊響應。目標是讓博茨瓦納路線既有豐富變化，也保持清晰、穩定的執行節奏。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA15}" alt="李志強與Desert & Delta Safaris代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Desert & Delta Safaris代表在WAA 2026現場合影。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">這次交流會怎樣影響自由曠野的Safari產品？</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">WAA之後，自由曠野旅行將把這些一線資訊逐步用於非洲Safari方案設計：根據季節選擇營地，而不是只看品牌；根據客人年齡、體能和興趣匹配活動；在報價前明確兒童政策、用車方式、行李限制和接駁條件；在多國或多營地路線中縮短資訊鏈路；把保護、社區和在地文化納入旅行體驗，而不是只追求酒店等級。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">對客人而言，這些行業交流最直接的價值，不是多出一串品牌名稱，而是獲得更適合自己的路線、更清楚的選擇理由，以及出現變化時更高效的溝通。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">WAA 2026現場交流影像</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">以下照片均為李志強在WAA展會現場與相關品牌代表的真實交流合影。照片記錄的是面對面溝通和友好聯繫，不單獨作為簽約、獨家代理或官方授權證明。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA02}" alt="李志強與Singita代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Singita代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA01}" alt="李志強與Lemala Camps & Lodges代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Lemala Camps & Lodges代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA03}" alt="李志強與Belmond代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Belmond代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA04}" alt="李志強與One Nature代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與One Nature代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA05}" alt="李志強與Angama代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Angama代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA06}" alt="李志強與Machaba Safaris代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Machaba Safaris代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA07}" alt="李志強與Jao Reserve代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Jao Reserve代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA08}" alt="李志強與The Bushcamp Company代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與The Bushcamp Company代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA09}" alt="李志強與Songa Africa代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Songa Africa代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA10}" alt="李志強與Karibu Camps & Lodges代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Karibu Camps & Lodges代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA11}" alt="李志強與Acacia Collections代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Acacia Collections代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA12}" alt="李志強與Sisini Collection代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Sisini Collection代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA13}" alt="李志強與Kantabile Afrika代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Kantabile Afrika代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA14}" alt="李志強與Okavango Hidden Gems代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Okavango Hidden Gems代表在WAA 2026現場合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA15}" alt="李志強與Desert & Delta Safaris代表在WAA 2026現場合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志強與Desert & Delta Safaris代表在WAA 2026現場合影。</p>
</div>

<div class="bg-[#e8f0e0] rounded-xl p-6 md:p-8 my-10">
  <p class="text-[#1a4a1a] font-bold text-lg mb-2">關於自由曠野旅行</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed">自由曠野旅行（Free Wilderness Travel）由成都自由曠野國際旅行社有限公司運營，專注非洲Safari、極地探索及自然類高端定製旅行。團隊通過目的地考察、行業展會交流和在地資源溝通，持續更新行程設計與服務資訊，為旅行者提供一對一方案建議。</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed mt-2">如果你正在規劃坦桑尼亞動物大遷徙、肯尼亞馬賽馬拉、博茨瓦納奧卡萬戈三角洲、贊比亞步行Safari或多國聯遊，可以向自由曠野旅行說明出行月份、人數、預算、兒童年齡和體驗偏好，由旅行顧問協助匹配路線與營地。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6 text-sm text-stone-500">資料說明：展會背景參考We Are Africa官方公開資訊；品牌目的地和產品資訊參考各品牌官網。文中「交流重點」為基於現場會談主題及品牌公開資料進行的編輯整理，不是逐字會議紀要。具體產品、價格、房態、合作關係和服務內容以相關方後續書面確認及實際預訂為準。</p>
`;

/* ─────────────────────────────────────────────
   實地考察：2026 非洲多國高端 Safari 野奢資源調研（繁體）
   路由：/wiki/brand/founder-africa-luxury-scouting-2026
   ───────────────────────────────────────────── */
const founderScoutContent = `
<p class="text-base md:text-lg leading-[1.8] mb-6">2026年上半年，自由曠野旅行創始人李志強受 Belmond、Wilderness、African Bush Camps、Sirikoi、Cottar's Safaris 多家非洲野奢旅行品牌邀請，先後赴肯尼亞、博茨瓦納、盧旺達，對當地多處高端野生動物保護區及野奢營地開展實地調研。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">非洲 Safari 旅行的實際體驗，受保護區區位、季節氣候、營地硬體資源、車輛嚮導服務、區域交通銜接多重現實條件制約。對於從事非洲出境旅行的從業者而言，赴目的地實地走訪核驗，是梳理資源、認知產品差異的重要途徑。本次調研覆蓋東非、南部非洲不同類型 Safari 目的地，涉及草原、內陸三角洲濕地、山地森林等差異化生態。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">調研人</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">調研人：李志強，自由曠野旅行創始人，深耕非洲高端 Safari 旅行領域多年，長期走訪非洲多國野奢營地與自然保護區，專注非洲 Safari 目的地資源調研。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT01}" alt="自由曠野旅行創始人李志強" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">自由曠野旅行創始人李志強。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">1月｜肯尼亞：私屬保護區 Safari 資源調研</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2026年1月，調研在肯尼亞開展，重點走訪萊瓦野生動物保護區內 Sirikoi 營地，以及馬賽馬拉私人保護區的 Cottar's 1920s Camp。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">萊瓦野生動物保護區面積超60平方公里，區內僅佈局5處營地，整體遊客接待密度較低，同時也是肯尼亞犀牛保護的重要區域，承擔黑、白犀牛保護相關工作。調研過程中，重點梳理了萊瓦保護區遊獵動線、保護區運營模式，以及當地野生動物保護落地實踐。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT02}" alt="肯尼亞萊瓦野生動物保護區內的Sirikoi營地" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">肯尼亞萊瓦野生動物保護區內的 Sirikoi 營地。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">Cottar's 1920s Camp 坐落於馬賽馬拉私人保護區，地處肯尼亞與坦桑尼亞交界地帶，營地選址海拔2100餘米，視野可俯瞰塞倫蓋蒂北部區域。該營地於2025年完成升級，帳篷採用全紗窗通風設計，配套露台與私人泡池，可提供私人嚮導、四驅遊獵車輛、徒步 Safari 以及在地文化探訪等體驗項目。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT03}" alt="馬賽馬拉私人保護區的Cottar's 1920s Camp" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">馬賽馬拉私人保護區的 Cottar's 1920s Camp。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">本次實地走訪，收集了馬賽馬拉及周邊私人保護區的一線實地資訊，為理解不同保護區組合線路的現實差異提供參考。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">5月中旬｜博茨瓦納：三角洲與陸地生態營地調研</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2026年5月，調研團隊在博茨瓦納開展十餘天實地走訪，先後體驗 Belmond、African Bush Camps 旗下多家代表性營地，對比奧卡萬戈三角洲濕地、喬貝國家公園陸地兩大截然不同的 Safari 生態體系。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT04}" alt="博茨瓦納奧卡萬戈三角洲與喬貝國家公園的Safari生態" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">博茨瓦納奧卡萬戈三角洲濕地與喬貝國家公園陸地兩大 Safari 生態體系。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">Belmond 在博茨瓦納運營兩處 Safari 營地，分別為 Eagle Island Lodge 與 Savute Elephant Lodge。Eagle Island Lodge 坐落於世界自然遺產奧卡萬戈三角洲的 Xaxaba 島嶼，共有12間客房，客房配備私人泳池。依託三角洲水系條件，可開展陸地遊獵、Mokoro 獨木舟、水上觀光、直升機遊覽等多種體驗。奧卡萬戈三角洲旅行體驗受水位季節性波動影響顯著，水位變化直接決定可開展的遊玩項目。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT05}" alt="Belmond Eagle Island Lodge坐落於奧卡萬戈三角洲" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">Belmond Eagle Island Lodge 坐落於奧卡萬戈三角洲 Xaxaba 島嶼。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">Savute Elephant Lodge 地處喬貝國家公園薩武特河道沿線，設置12間帳篷客房，營地毗鄰永久動物水源點，以陸地野生動物遊獵為核心體驗，搭配自然科普與本土人文活動。該營地與奧卡萬戈三角洲水域營地形成生態場景的鮮明對比。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT06}" alt="喬貝國家公園薩武特河道沿線的Savute Elephant Lodge" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">喬貝國家公園薩武特河道沿線的 Savute Elephant Lodge。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">同期，調研還走訪 African Bush Camps 旗下 Khwai Leadwood 與 Atzaró Okavango Camp 兩處營地。Khwai Leadwood 地處 Khwai 區域，周邊彙集河道、林地、開闊草原多重地貌，調研重點記錄該片區動物觀測條件、遊客車輛密度、可開展活動類型，以及與莫雷米保護區周邊區域的通行銜接情況。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT07}" alt="African Bush Camps旗下Khwai Leadwood營地" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">African Bush Camps 旗下 Khwai Leadwood 營地。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">Atzaró Okavango Camp 是 African Bush Camps 近年推出的高端營地項目，位於奧卡萬戈三角洲腹地。營地保留荒野生態屬性的同時，側重住宿空間設計、餐飲康養類配套，區別於傳統以高強度動物觀測為主的 Safari 營地，適配希望兼顧遊獵體驗與休閒度假節奏的客群。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT08}" alt="African Bush Camps旗下Atzaró Okavango Camp高端營地" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">African Bush Camps 旗下 Atzaró Okavango Camp 高端營地。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">博茨瓦納不同營地分屬不同生態片區，線路規劃需要結合營地所處地貌、季節水位條件，同時考量內陸小飛機接駁、嚮導車隊配置、跨區域路線串聯等現實問題，也是本次調研重點關注的內容。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">5月底｜盧旺達：山地大猩猩生態旅行調研</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">結束博茨瓦納行程後，2026年5月底，調研團隊受 Wilderness 邀請，前往盧旺達，實地考察 Wilderness Bisate 營地及火山國家公園相關旅行資源。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">Bisate 營地毗鄰火山國家公園，該區域旅行核心為山地大猩猩追蹤，與東非草原、博茨瓦納三角洲的 Safari 模式存在明顯區別。大猩猩追蹤出行受國家公園管理制度、徒步難度、許可配額等多重條件約束。本次調研梳理火山國家公園周邊交通、大猩猩追蹤活動組織流程，以及盧旺達高端自然旅行的服務流程，同時考察盧旺達與東非 Safari 線路之間的聯動可行性。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT09}" alt="盧旺達火山國家公園毗鄰的Wilderness Bisate營地" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">盧旺達火山國家公園毗鄰的 Wilderness Bisate 營地。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">行業觀察結語</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">非洲高端 Safari 旅行，並不簡單等同於高端住宿的疊加，目的地生態條件、季節週期、營地區位、在地服務體系，共同決定旅行產品的實際落地效果。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">隨著國內高端出境遊需求增長，遊客對非洲 Safari 的需求逐步從標準化觀光，轉向沉浸式、個性化的深度體驗。非洲不同國家之間地貌、物種、保護政策差異巨大，草原、內陸濕地、山地森林形成各自獨立的旅行體系。行業從業者需要持續跟進目的地營地迭代、生態季節變化，釐清不同區域資源的適配邊界，才能匹配國內遊客多元化出行訴求，推動非洲野奢旅行向更精細化的方向發展。</p>

<div class="bg-[#e8f0e0] rounded-xl p-6 md:p-8 my-10">
  <p class="text-[#1a4a1a] font-bold text-lg mb-2">關於自由曠野旅行</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed">自由曠野旅行（Free Wilderness Travel）由成都自由曠野國際旅行社有限公司運營，專注非洲 Safari、南北極及自然類高端定製旅行。團隊通過目的地實地考察、營地入住核驗與在地資源溝通，持續更新線路設計與服務資訊，為旅行者提供一對一方案建議。</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed mt-2">官方網站：<a href="https://freewds.com/" class="text-[#1a4a1a] hover:underline" target="_blank" rel="noopener noreferrer">https://freewds.com/</a></p>
</div>
`;

const founderScoutFaq = [
  {
    question: '這次實地調研覆蓋了哪些國家和營地？',
    answer: "2026年上半年，調研覆蓋肯尼亞、博茨瓦納、盧旺達三個國家，實地走訪了萊瓦 Sirikoi 營地、Cottar's 1920s Camp、Belmond 旗下 Eagle Island Lodge 與 Savute Elephant Lodge、African Bush Camps 旗下 Khwai Leadwood 與 Atzaró Okavango Camp，以及盧旺達 Wilderness Bisate 營地等。",
  },
  {
    question: '實地調研對旅行者有什麼實際幫助？',
    answer: '實地走訪讓自由曠野旅行能更準確判斷營地所在區域、季節水位、活動方式、交通銜接與服務細節，從而為不同客人匹配更合適的 Safari 路線與營地組合，而不是只看品牌知名度或公開圖片。',
  },
  {
    question: '這些實地走訪是否代表已簽署獨家合作協議？',
    answer: '不代表。實地考察與入住體驗證明團隊進行過真實抵達與現場核驗，但不單獨等同於簽約、獨家代理或官方授權。具體合作產品、價格、房態以相關方後續書面確認及實際預訂為準。',
  },
];

export const wikiBrandArticlesZhTw: WikiBrandArticle[] = [
  {
    slug: 'founder-field-notes',
    title: '從東非草原到盧旺達山地森林：李志強與自由曠野團隊的實地足跡',
    metaTitle: '從東非草原到盧旺達山地森林：李志強與自由曠野團隊的實地足跡',
    metaDescription: '李志強自2013年進入高端定製旅行行業，持續前往坦桑尼亞、博茨瓦納、盧旺達、南極和格陵蘭等目的地進行實地體驗。自由曠野旅行於2022年成立，並將長期目的地經驗用於非洲Safari、南北極及自然旅行的線路策劃與服務。',
    metaKeywords: '自由曠野旅行創始人,李志強,非洲Safari實地考察,坦桑尼亞Safari,博茨瓦納旅行,盧旺達大猩猩旅行,非洲旅行團隊',
    category: '品牌百科',
    subcategory: '人物故事',
    excerpt: '李志強自2013年進入高端定製旅行行業，持續前往坦桑尼亞、博茨瓦納、盧旺達、南極和格陵蘭等目的地進行實地體驗。自由曠野旅行於2022年成立，並將長期目的地經驗用於非洲Safari、南北極及自然旅行的線路策劃與服務。',
    content: founderFieldNotesContent,
    image: IMG_01,
    readTime: '',
    tags: ['品牌故事', '創始人', '實地考察', '非洲Safari', '南極', '盧旺達'],
    date: '',
    author: '',
    authorRole: '',
    faq: [],
  },
  {
    slug: 'brand-cooperation-exchange',
    title: '自由曠野旅行參加 We Are Africa 2026：與數十家非洲野奢品牌建立友好合作聯繫',
    metaTitle: '自由曠野旅行參加 We Are Africa 2026：與數十家非洲野奢品牌建立友好合作聯繫',
    metaDescription: '2026年5月，自由曠野旅行參加南非開普敦We Are Africa 2026，與Lemala、Singita、Belmond、One Nature、Angama等數十家非洲野奢品牌建立友好合作聯繫。',
    metaKeywords: '自由曠野旅行,We Are Africa 2026,WAA,非洲野奢品牌,品牌合作,非洲Safari',
    category: '品牌百科',
    subcategory: '品牌合作',
    excerpt: '2026年5月，自由曠野旅行前往南非開普敦參加We Are Africa 2026，與數十家非洲野奢酒店及旅行品牌代表進行面對面交流，圍繞Safari線路、親子蜜月產品、旺季資源協調等議題交換資訊，建立直接合作聯繫。',
    content: brandMeetingsContent,
    image: BRAND_MEETINGS_DESKTOP,
    readTime: '12分鐘',
    tags: ['品牌合作', 'We Are Africa', '野奢營地', '非洲Safari', '實地考察'],
    date: '2026-09-04',
    author: '自由曠野旅行',
    authorRole: '品牌團隊',
    faq: brandMeetingsFaq,
  },
  {
    slug: 'founder-africa-luxury-scouting-2026',
    title: '2026年自由曠野旅行創始人李志強赴非洲多國開展高端Safari野奢資源實地調研',
    metaTitle: '2026年自由曠野旅行創始人李志強赴非洲多國開展高端Safari野奢資源實地調研',
    metaDescription: "2026年上半年，自由曠野旅行創始人李志強受邀赴肯尼亞、博茨瓦納、盧旺達，實地調研 Belmond、Wilderness、African Bush Camps、Sirikoi、Cottar's Safaris 等高端野奢營地的保護區區位、季節氣候、營地硬體與交通銜接，為高端 Safari 線路設計提供一手判斷依據。",
    metaKeywords: '自由曠野旅行,李志強,非洲Safari實地調研,肯尼亞Sirikoi,博茨瓦納Belmond,盧旺達Bisate,高端野奢營地,山地大猩猩追蹤',
    category: '品牌百科',
    subcategory: '實地考察',
    excerpt: "2026年上半年，自由曠野旅行創始人李志強受邀赴肯尼亞、博茨瓦納、盧旺達，實地調研 Sirikoi、Cottar's、Belmond、Wilderness 等高端野奢營地，為高端 Safari 線路設計積累一手判斷。",
    content: founderScoutContent,
    image: SCOUT01,
    readTime: '8分鐘',
    tags: ['實地考察', '非洲Safari', '野奢營地', '肯尼亞', '博茨瓦納', '盧旺達'],
    date: '2026-09-04',
    author: '李志強',
    authorRole: '自由曠野旅行創始人',
    faq: founderScoutFaq,
  },
];